export const toggle = () => {
  // $('.home .pattern-toggle .wp-block-heading').click(function (e) {
  //   e.stopPropagation();
  //   $(this).closest('.pattern-toggle').toggleClass('is-active');
  // });

  // job toggle
  $('.job-toggle .wp-block-heading').click(function (e) {
    e.stopPropagation();
    $(this).closest('.job-toggle').toggleClass('is-active');
  });

  // contact toggle
  $('.pattern-locations-b .wp-block-column > .wp-block-heading').click(
    function (e) {
      e.stopPropagation();
      $(this).closest('.wp-block-column').toggleClass('is-active');
    },
  );

  // faq toggle
  $('.pattern-faq > .wp-block-heading').click(function (e) {
    e.stopPropagation();
    $(this).parent().toggleClass('is-active');
  });
};
